export const normalizeTerritory = (value = '') => String(value).toLowerCase().normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '').replace(/[_-]/g, ' ')
  .replace(/^(provincia de|provincia del|provincia|departamento|partido|municipio|barrio|distrito)\s+/, '')
  .replace(/\s+/g, ' ').trim();

export const provinceCode = (value = '') => ({
  mendoza:'mendoza',
  'san juan':'san_juan',
  'san luis':'san_luis',
}[normalizeTerritory(value)] || '');
